/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import styles from './Buttons.module.css';


/*****************************************
 * * CREATE COMPONENT
 *****************************************/
// button with image
class ImgBtn extends Component {
  static defaultProps = {
    title: ""
  }
  render() {
    return (
      <button
        type="button"
        className={styles.img}
        onClick={this.props.onClick}
        title={this.props.title}
        disabled={this.props.disabled}
        // dataToolTip={this.props.dataToolTip}
      >
        <img src={this.props.src} alt="" aria-hidden="true" />
      </button>
    );
  }
}

export default ImgBtn;
